<div
  class="file-input"
  tabindex="0"
  (keydown.enter)="input.click()"
  (keydown.space)="input.click()"
  (blur)="onTouched()"
>
  <svg-icon class="file-input__icon" icon="exp-notes" width="1.5em"></svg-icon>

  <label class="file-input__incentive" [attr.for]="id" i18n>Glisser ou sélectionner votre CV ici</label>

  <p class="file-input__accepted-file" i18n>fichier .pdf .doc(x) .jp(e)g .png - 8Mo max</p>

  <input
    class="file-input__input"
    #input
    [id]="id"
    type="file"
    (change)="doChange($event.target.files)"
    accept=".pdf, .doc, .docx, .jpeg, .jpg, .png"
    tabIndex="-1"
    [disabled]="disabled"
    (click)="openFileInput.emit()"
  />
</div>
